import { render } from "./appletRelease.vue?vue&type=template&id=74622ff8"
import script from "./appletRelease.vue?vue&type=script&lang=js"
export * from "./appletRelease.vue?vue&type=script&lang=js"

import exportComponent from "F:\\code\\ywym\\ydd-zht-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__